const getUnique = (items) => [...new Set(items)];

export default getUnique;
